import loadable from "utils/loadable";

export const HalamanUploadEbooks = loadable(() => import("./index"));
export const PopupData = loadable(() => import("./PopupData"));
